const GITHUB_CONSTANTS = 'https://github.com/bitcoin-ultimatum/orion';
const EXPLORER_MAINNET = 'https://explorer.btcu.io/?mainnet';
const EXPLORER_TESTNET = 'https://explorer.btcu.io/?orion';

export {
    GITHUB_CONSTANTS,
    EXPLORER_MAINNET,
    EXPLORER_TESTNET,
};
